exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/referral/create-referral/create-referral.component.css
// module id = ../../../../../src/app/main/referral/create-referral/create-referral.component.css
// module chunks = main